export default __webpack_public_path__ + "static/media/lager_822_hero.4e14124c.png";